exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parts-header-sign-in[data-v-2caee3d8]{color:#90969d;text-decoration:none;text-transform:uppercase}.parts-header-sign-in[data-v-2caee3d8]:hover{text-decoration:none;color:#51acff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2caee3d8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/header/SignLink.vue
// module id = f7bf885a34d66d500aea
// module chunks = 8